import React, { Component } from 'react';
import ArticlesCards from '../homepage-cards/articles-cards/ArticlesCardsList';
import { lang } from '../../lang';
import { withTranslation } from 'react-i18next';

class HomepageFourth extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        const { t } = this.props;
        let articles = [{title: 'test', en_title: 'en_test', img: '', link: '/'}]
        return (
            <div className='hp hp-fourth'>
                <div className='fourth-statement'>
                    <h2>{t('homepage.resouces.title')}</h2>
                    <h5>{t('homepage.resouces.desc')} </h5>
                </div>
                <ArticlesCards size={4} nowrap articles={this.props.articles} />
            </div>
        );
    }
}

export default withTranslation()(HomepageFourth);
